import React from 'react';
import PropTypes from 'prop-types';
import {loginUiTexts} from 'data/ui-texts';
import {getText} from 'helpers/language-helper';
import Button from 'components/button/button';
import './login-facilitator.scss';

const LoginFacilitator = (props) => {
	let {
		isLoading,
		showResetPasswordBox,
		passwordIsReset,
		invalidInputEmail,
		invalidInputPassword,
		languageId,
		email,
		password,
		errMsg,
		handleInput,
		handleLogin,		
		toggleResetPasswordBox,
		handleResetPassword
	} = props;


	if (isLoading && !showResetPasswordBox) {
		return (
			<div className="LoginFacilitator">
				<div className="LoginFacilitator-loadingWrapper" />
			</div>
		);
	}

	if (showResetPasswordBox) {
		return (
			<React.Fragment>
				<div className="LoginFacilitator">
					{!passwordIsReset && 
					<form className="LoginFacilitator-form reset" onSubmit={() => {handleResetPassword();}}>
						<p className="LoginFacilitator-info">{getText(loginUiTexts.resetPassword, languageId)}</p>
						<input
							className={invalidInputEmail ? ' invalid' : ''}
							name="email"
							type="text"
							placeholder={getText(loginUiTexts.email, languageId)} 
							autoComplete="section-teacherlogin email"
							value={email ? email : ''} 
							onChange={(event)=>{handleInput(event);}}
						/>
						<p className="LoginFacilitator-errorMessage">{errMsg}</p> 
						
						<Button 
							text={getText(loginUiTexts.reset, languageId)} 
							classes={['login']} 
							isLoading={isLoading}
							onClick={() => {handleResetPassword();}}
						/>
					</form>}
					{passwordIsReset && 
						<form className="LoginFacilitator-form feedback">
							<p className="LoginFacilitator-info">
								{getText(loginUiTexts.passwordResetFeedback, languageId)}
							</p>
							<p 
								className="LoginFacilitator-infoLink"
								onClick={() => {toggleResetPasswordBox();}} 
							>{getText(loginUiTexts.backToLogin, languageId)}</p>
						</form>}
				</div>
				<div 
					onClick={() => {toggleResetPasswordBox();}} 
					className="LoginFacilitator-resetPasswordBtn"
				>{getText(loginUiTexts.backToLogin, languageId)}</div>
			</React.Fragment>
		);
	}

	return (
		<React.Fragment>
			<div className="LoginFacilitator">
				<form className="LoginFacilitator-form" onSubmit={handleLogin}>
					<input
						className={invalidInputEmail ? ' invalid' : ''}
						name="email"
						type="text"
						placeholder={getText(loginUiTexts.email, languageId)} 
						autoComplete="section-teacherlogin email"
						value={email ? email : ''} 
						onChange={(event)=>{handleInput(event);}}
					/>
					<input
						className={invalidInputPassword ? ' invalid' : ''}
						name="password"
						type="password"
						placeholder={getText(loginUiTexts.password, languageId)}
						autoComplete="section-teacherlogin password"
						value={password ? password : ''} 
						onChange={(event)=>{handleInput(event);}}
					/>
					<p className="LoginFacilitator-errorMessage">{errMsg}</p> 
					<Button text={getText(loginUiTexts.login, languageId)} classes={['login']} onClick={handleLogin} />
				</form>
			</div>
			<div 
				onClick={() => {toggleResetPasswordBox();}} 
				className="LoginFacilitator-resetPasswordBtn"
			>{getText(loginUiTexts.forgotPassword, languageId)}</div>
		</React.Fragment>
	);
};

LoginFacilitator.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	showResetPasswordBox: PropTypes.bool.isRequired,
	passwordIsReset: PropTypes.bool.isRequired,
	invalidInputEmail: PropTypes.bool.isRequired,
	invalidInputPassword: PropTypes.bool.isRequired,
	languageId: PropTypes.string.isRequired,
	email: PropTypes.string,
	password: PropTypes.string,
	errMsg: PropTypes.string,
	handleLogin: PropTypes.func.isRequired,
	handleInput: PropTypes.func.isRequired,
	toggleResetPasswordBox: PropTypes.func.isRequired,
	handleResetPassword: PropTypes.func.isRequired,
};

export default LoginFacilitator;